import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { classNames, Column, Icon, List, Row } from '@pella/sash-framework';
import { Image, CTA } from '../../../';
import { isValidArray } from '../../../utilities/validations';

import './index.css';

const ProductStyleTabs = ({ data, className, showCobs }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [showMobileTabs, setShowMobileTabs] = useState(false);

	if (!isValidArray(data)) return null;

	const onTabClick = (index) => {
		setActiveIndex(index);
		setShowMobileTabs(false);
	};

	const onMobileBtnClick = () => setShowMobileTabs(!showMobileTabs);

	const tabClasses = (index) =>
		classNames({
			'px-2 w-full py-1.5 text-left': true,
			'lg:py-0.5 lg:border-l-3 text-subtitle': !showCobs,
			'lg:p-3 hover:bg-white lg:h-full lg:text-center text-subtitle-2 max-lg:flex max-lg:items-center max-lg:gap-x-5': showCobs,
			'border-l-gray-45 text-gray-50 hover:text-gray-75': !showCobs && activeIndex !== index,
			'border-l-primary': !showCobs && activeIndex === index,
			'bg-white': showCobs && activeIndex === index,
		});

	return (
		<div className={`productStyleTabs lg:grid ${showCobs ? 'lg:grid-cols-[300px_1fr]' : 'lg:grid-cols-[220px_1fr]'} lg:gap-x-6 ${className || ''}`}>
			<div className='productStyleTabs-tabs'>
				<button
					className={`flex w-full items-center justify-between text-base max-lg:mb-4 max-lg:border max-lg:border-black max-lg:px-4 max-lg:py-3 lg:pointer-events-none lg:mb-4 lg:p-0 lg:text-lg lg:font-semibold ${showCobs ? 'lg:hidden' : ''}`}
					onClick={onMobileBtnClick}
				>
					<span>{data?.[activeIndex]?.heading || 'Select a Style'}</span>
					<Icon
						name={showMobileTabs ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
						className='lg:hidden'
					/>
				</button>

				<List
					bullets='none'
					className={`divide-y divide-gray-10 max-lg:mb-4 lg:divide-y-0 ${showMobileTabs ? '' : 'max-lg:hidden'} ${showCobs ? 'scroll-gradient lg:grid lg:h-[588px] lg:grid-cols-2 lg:gap-4 lg:overflow-y-auto' : 'lg:space-y-3'}`}
				>
					{data.map((item, index) => (
						<li
							key={index}
							className='md:h-full'
						>
							<button
								onClick={() => onTabClick(index)}
								className={tabClasses(index)}
							>
								{showCobs && item.cob?.url && (
									<Image
										data={{ image: item.cob }}
										className='mx-auto hidden aspect-square h-14 flex-none lg:mb-2 lg:!block lg:h-20'
									/>
								)}
								<span className='flex-1'>{item.heading}</span>
							</button>
						</li>
					))}
				</List>
			</div>

			<div className='productStyleTabs-content'>
				<Row
					className='md:h-full'
					noGutters
				>
					{isValidArray(data?.[activeIndex]?.content?.image) && (
						<Column
							xs={12}
							md={7}
							xl={8}
						>
							<Image
								data={data?.[activeIndex].content.image[0]}
								className='!block h-full'
							/>
						</Column>
					)}

					<Column
						xs={12}
						md='fluid'
					>
						<div className='bg-black p-6 md:flex md:h-full md:flex-col md:justify-center md:px-6 lg:py-12'>
							{data?.[activeIndex]?.content?.heading && (
								<h3
									className='mb-4 font-semibold text-white'
									dangerouslySetInnerHTML={{ __html: data?.[activeIndex].content.heading }}
								/>
							)}
							{data?.[activeIndex]?.content?.description && (
								<div
									dangerouslySetInnerHTML={{ __html: data?.[activeIndex].content.description }}
									className='text-white md:text-base xl:text-lg'
								/>
							)}
							{isValidArray(data?.[activeIndex]?.content?.cta) && (
								<CTA
									data={data?.[activeIndex].content.cta[0]}
									className='mt-6 !justify-start !text-left text-white'
								/>
							)}
						</div>
					</Column>
				</Row>
			</div>
		</div>
	);
};

ProductStyleTabs.propTypes = {
	data: PropTypes.array.isRequired,
	className: PropTypes.string,
	showCobs: PropTypes.bool,
};

export default ProductStyleTabs;
